import axios from 'axios';

const getResource = async (fileName) => {
    const s3Call = axios.create({
        baseURL: 'https://opus-resources.s3.amazonaws.com'
    });
    const s3Response = await s3Call.get(`${fileName}?${Math.random()}`);
    if (!s3Response.data) {
        return {};
    }
    return s3Response.data;
};

const S3 = {
    getResource
};

export default S3;
